import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CampusHeader from '../../../components/feature/CampusHeader';
import Footer from '../../../components/feature/Footer';
import { auth } from '../../../lib/firebase';
import { applyActionCode, reload } from 'firebase/auth';
import { getUserRole } from '../../../services/auth';

const VerifyEmailPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const oobCode = searchParams.get('oobCode');
    if (!oobCode) {
      setStatus('Missing verification code.');
      setLoading(false);
      return;
    }
    (async () => {
      try {
        await applyActionCode(auth, oobCode);
        const u = auth.currentUser;
        if (u) {
          await reload(u);
          if (u.emailVerified) {
            const { role, status: sellerStatus } = await getUserRole(u.uid);
            if (role === 'seller') {
              navigate(sellerStatus === 'pending' ? '/pending-verification' : '/seller-dashboard', { replace: true });
              return;
            }
            if (role === 'buyer') {
              navigate('/buyer-dashboard', { replace: true });
              return;
            }
            navigate('/', { replace: true });
            return;
          }
        }
        setStatus('Email verified successfully. Continue to your account.');
      } catch (e: any) {
        setStatus('Verification failed or link expired.');
      } finally {
        setLoading(false);
      }
    })();
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen bg-white">
      <CampusHeader />
      <main className="max-w-md mx-auto px-4 py-8 md:py-12">
        <div className="bg-white rounded-lg shadow-lg p-6 md:p-8 text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Verify Email</h1>
          {loading ? (
            <p className="text-gray-600">Verifying your email, please wait…</p>
          ) : (
            <>
              <p className="text-gray-700 mb-6">{status}</p>
              <button
                onClick={() => {
                  if (auth.currentUser) {
                    navigate('/auth/email-verification', { replace: true });
                    return;
                  }
                  navigate('/auth/sign-in');
                }}
                className="w-full px-4 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
              >
                Continue
              </button>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default VerifyEmailPage;
